import * as React from 'react';
import Avatar from '@mui/material/Avatar';

interface Props {
  name: any;
  image?: any;
  size?: any;
}

export default function AppAvatar(props: Props) {
  const size = props.size ? props.size : 56;

  const safeName =
    typeof props.name === 'string' && props.name.trim()
      ? props.name.trim()
      : 'N N';

  const safeImage =
    typeof props.image === 'string' &&
    props.image.trim() &&
    props.image !== 'undefined' &&
    props.image !== 'null'
      ? props.image.trim()
      : undefined;

  const firstLetter = safeName.charAt(0).toUpperCase();
  const nameParts = safeName.split(/\s+/);
  const secondLetter =
    nameParts.length > 1 ? nameParts[1].charAt(0).toUpperCase() : '';

  return (
    <Avatar
      sx={{ width: size, height: size }}
      src={safeImage}
    >
      {firstLetter + secondLetter}
    </Avatar>
  );
}
